import selectors from '../../../rootSelectors';
import { playStimulusAudio } from '../../../common/stimulus/stimulusButtonActions';
import { playAvatarAudio } from '../../../common/avatar/avatarActions';
import { highlightPossibleResponse, playResponseAudio, resetQuestionsAndTimeTrackingState }
    from '../../../common/questions/questionsActions';
import { goToStartPage, goToQuestion } from '../../../common/navigation/navigationActions';
import IPS_AUDIO_INSTRUCTIONS from '../../ipsConstants';
import { GENERAL_AUDIO_DELAY, ONE_SECOND } from '../../../constants/time';
import { IPS } from '../../../constants/measure';
import { QUESTIONS } from '../../../constants/assessmentItemType';

export const playQuestionsScript = (stimulusAudio, possibleResponses) => async (dispatch) => {
    await dispatch(playStimulusAudio([stimulusAudio], GENERAL_AUDIO_DELAY));
    dispatch(highlightPossibleResponse(possibleResponses[0].id));
    await dispatch(playResponseAudio(possibleResponses[0].audio, 0, ONE_SECOND));
    dispatch(highlightPossibleResponse(possibleResponses[1].id));
    await dispatch(playResponseAudio(possibleResponses[1].audio, 1, GENERAL_AUDIO_DELAY));
    dispatch(highlightPossibleResponse(possibleResponses[2].id));
    await dispatch(playResponseAudio(possibleResponses[2].audio, 2, GENERAL_AUDIO_DELAY));
};

export const narrateQuestionsScreen = (questionSpecificAudio, stimulusAudio, possibleResponses) => async (dispatch) => {
    await dispatch(playAvatarAudio(
        [
            IPS_AUDIO_INSTRUCTIONS.questionsInstruction,
            questionSpecificAudio,
            IPS_AUDIO_INSTRUCTIONS.questionsInstructionGeneral,
        ],
        GENERAL_AUDIO_DELAY,
    ));
    return dispatch(playQuestionsScript(stimulusAudio, possibleResponses));
};

export const onNextButtonClick = (questionIndex) => (dispatch, getStore) => {
    const state = getStore();
    const isLastQuestion = selectors.getIPSTotalQuestions(state, QUESTIONS) < questionIndex + 1;
    if (isLastQuestion) {
        dispatch(goToStartPage());
    } else {
        dispatch(goToQuestion(IPS.ASSESSMENT, null, questionIndex + 1));
        dispatch(resetQuestionsAndTimeTrackingState());
    }
};
